import { createApi } from '@reduxjs/toolkit/query/react';
import { State } from '../../types';
import { GeographicService } from './geographic-service';
import { baseQueryStub } from '../../utils';

// A helper function to initialize the service once when needed
let geographicService: GeographicService | null = null;
const getGeographicService = () => {
  geographicService ??= new GeographicService();
  return geographicService;
};

// Define an API service using RTK Query that uses the GeographicService
export const geographicApi = createApi({
  reducerPath: 'geographicApi',
  baseQuery: baseQueryStub,
  tagTypes: ['Geographic'],
  endpoints: builder => ({
    getAllStates: builder.query<State[], void>({
      queryFn: async () => {
        const geographicService = getGeographicService();
        const states = await geographicService.getAllStates();
        return { data: states };
      },
      providesTags: ['Geographic'],
      // Keep states in cache for the entire session since they don't change
      keepUnusedDataFor: 3600 * 24, // 24 hours
    }),
  }),
});

export const { useGetAllStatesQuery } = geographicApi;
